import { Appointments } from '@devexpress/dx-react-scheduler-material-ui'

import { Box } from '@mui/material'

import { Slot } from '@/core/models/schedule.model'

import { SchedulerDataType } from '../enums/scheduler-data-type.enum'
import dayjs from 'dayjs'

export type AppointmentProps = Appointments.AppointmentProps

export const defaultColor = '#64b5f6'

export function AgendaAppointment(props: AppointmentProps) {
  const { children, data, ...rest } = props

  const appointmentTotalDuration = dayjs(data.endDate).diff(data.startDate, 'minutes')

  return (
    <Appointments.Appointment
      {...rest}
      data={data}
      style={{
        position: 'relative',
        backgroundColor: data.type === SchedulerDataType.UNAVAILABILITY
          ? '#e0e0e0'
          : (data.type === SchedulerDataType.CONSULTATION || data.type === SchedulerDataType.ORDER) ? data?.color : 'transparent',
        borderRadius: '8px',
        opacity: data.type === SchedulerDataType.UNAVAILABILITY ? 0.6 : 1,
        pointerEvents: data.type === SchedulerDataType.UNAVAILABILITY ? 'none' : 'auto',
        ...(data.type === SchedulerDataType.UNAVAILABILITY
          ? {
              backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 5px, rgba(0,0,0,0.05) 5px, rgba(0,0,0,0.05) 10px)',
            }
          : {}),
        ...(data.type === SchedulerDataType.SCHEDULE
          ? {
              borderColor: data?.color ?? defaultColor,
              color: data?.color ?? defaultColor,
            }
          : {}),
      }}
    >
      {children}
      {data.busySlots?.map((busySlot: Slot) => (
        <Box
          key={`${data.id}-${new Date(busySlot.start).getTime()}`}
          sx={{
            backgroundColor: data?.color,
            position: 'absolute',
            // zIndex: -1,
            top: (dayjs(busySlot.start).diff(data.startDate, 'minutes') / appointmentTotalDuration) * 100 + '%',
            width: '100%',
            height: (dayjs(busySlot.end).diff(busySlot.start, 'minutes') / appointmentTotalDuration) * 100 + '%',
            opacity: 0.3,
            color: 'white',
          }}
        ></Box>
      ))}
    </Appointments.Appointment>
  )
}

function AgendaAppointmentContent({ data, ...rest }: Appointments.AppointmentContentProps) {
  let style = {}
  if (data.type === SchedulerDataType.SCHEDULE) {
    style = { ...style, color: data?.color ?? defaultColor }
  } else if (data.type === SchedulerDataType.ORDER) {
    style = { ...style, color: '#fff' }
  }
  return <Appointments.AppointmentContent {...rest} data={data} style={style} />
}

function AgendaAppointmentContainer(props: Appointments.ContainerProps) {
  return <Appointments.Container {...props} />
}

export default function AgendaAppointments() {
  return (
    <Appointments
      appointmentComponent={AgendaAppointment}
      appointmentContentComponent={AgendaAppointmentContent}
      containerComponent={AgendaAppointmentContainer}
    />
  )
}
